import { render, staticRenderFns } from "./AmetrasEmailListFieldTemplate.vue?vue&type=template&id=2560c794&"
import script from "./AmetrasEmailListFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasEmailListFieldTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VChip,VCombobox})
